// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(min-width: 1024px)";
var _3 = "header-37SeL";
var _4 = "icon-2IsTP";
var _5 = "button-1CrXh";
export { _1 as "__esModule", _2 as "desktop_only", _3 as "header", _4 as "icon", _5 as "button" }
export default { "__esModule": _1, "desktop_only": _2, "header": _3, "icon": _4, "button": _5 }
